import React, { Fragment } from "react";
import LinkButton from "../../../button/LinkButton/LinkButton";
import { GENERAL } from "../../../../assets/images/images";
/**
 * @param {Object} props - The props object.
 * @param {Company} props.company - The company object (or undefined).
 */
const CompanyEmailInfo = (props) => {
  const { company, isDark } = props;

  if (!company?.email) {
    return <Fragment />;
  }

  return (
    <div className="company-info d-inline-flex">
      <div className="info-icon me-2">
        <img
          src={GENERAL.mail}
          alt="mail-icon"
          className={isDark ? 'filter-white' : ''}
        />
      </div>
      <LinkButton
        onClick={() => { }}
        styleClass="link-container d-flex align-items-center"
        textClass={`small ${isDark ? 'dark-background' : ''}`}
        isMailTo={true}
        valueLink={company?.email}
        valueText={company?.email}
      />
    </div>
  );
}
export default CompanyEmailInfo;